import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose, IoArrowBack, IoArrowForward } from "react-icons/io5";
import Calenderimg1 from "./Images/Calenderimg1.png";
import Calenderimg2 from "./Images/Calenderimg2.png";
import Calenderimg3 from "./Images/Calenderimg3.png";
import Calenderimg4 from "./Images/Calenderimg4.png";
import Calenderimg5 from "./Images/Calenderimg5.png";
import Calenderimg6 from "./Images/Calenderimg6.png";
import Calenderimg7 from "./Images/Calenderimg7.png";
 
const CalenderTour = ({ topic, onClose }) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const getServiceSteps = () => [
    {
      image: Calenderimg1,
      title: "Manage Boarding / Appointment Toggle",
      description:
        "Switch between Boarding and Appointment calendar view. Use this toggle to manage boarding bookings or staff appointments separately",
      popupPosition: { top: "20%", left: "18%" },
    },
    {
      image: Calenderimg2,
      title: "Select Date",
      description:
        "Click on this button to select a date for the calendar view.",
      popupPosition: { top: "12%", right: "5%" }, // right side
    },
    {
      image: Calenderimg3,
      title: "Add a New Booking ",
      description:
        "Click on this button to add a new booking or appointment directly from the calendar view.",
      popupPosition: { top: "10%", right: "15%" }, // left, a bit lower
    },
    {
      image: Calenderimg4,
      title: "Manage bookings through Calendar View",
      description:
        "Shows room-wise bookings and appointments in calendar format. You can also create bookings or appointments by selecting a date or slot from the calendar.",
      popupPosition: { bottom: "30%", left: "2%" },
    },
    {
      image: Calenderimg5,
      title: "Boarding Queue- bookings awaiting  confirmation ",
      description:
        "Displays bookings waiting for confirmation or room allocation.For boarding, select a room to confirm the booking. For appointments, select a staff member to assign the appointment.",
      popupPosition: { bottom: "20%", left: "15%" }, 
    },
    {
      image: Calenderimg6,
      title: "Booking Card - shows booking details ",
      description:
        "Each booking card shows booking details and current status.It includes booking ID, service name, pet details, payment amount, and booking status.",
      popupPosition: { top: "30%", right: "40%" }, 
    },
    {
      image: Calenderimg7,
      title: "Toggle to Appointment ",
      description:
        "Use this toggle to switch to appointment calendar view where you can manage staff appointments separately from boarding bookings.",
      popupPosition: { bottom: "30%", left: "2%" }, 
    },
  ];

  const steps = getServiceSteps();
  const totalSteps = steps.length;
  const current = steps[currentStep];

  const handleNext = () => {
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleSkip();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center">
      {/* Full-screen background image */}
      <div className="absolute inset-0">
        <img
          src={current.image}
          alt={`Step ${currentStep + 1}`}
          className="w-full h-full object-contain bg-black"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/1920x1080?text=Tour+Image";
          }}
        />
      </div>

      {/* Global skip button (top right) - optional but handy */}
      <button
        onClick={handleSkip}
        className="absolute top-4 right-4 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors z-30 backdrop-blur-sm"
        aria-label="Skip tour"
      >
        <IoClose size={24} />
      </button>

      {/* Step indicator dots (bottom center) */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-30">
        {steps.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentStep(idx)}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === currentStep
                ? "bg-white w-4"
                : "bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>

      {/* Positioned popup for the current step */}
      <div className="absolute z-30" style={current.popupPosition}>
        <div className="bg-white rounded-xl shadow-2xl w-72 md:w-80 p-5 animate-fadeIn">
          {/* Step number */}
          <div className="flex justify-between items-center mb-3">
            <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded-full">
              Step {currentStep + 1} of {totalSteps}
            </span>
            <button
              onClick={handleSkip}
              className="text-xs text-gray-400 hover:text-gray-600"
            >
              Skip
            </button>
          </div>

          {/* Title & description */}
          <h3 className="text-lg font-bold text-gray-800 mb-2">
            {current.title}
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {current.description}
          </p>

          {/* Navigation buttons inside the popup */}
          <div className="flex justify-between items-center mt-5 pt-3 border-t border-gray-100">
            <button
              onClick={handleBack}
              disabled={currentStep === 0}
              className={`flex items-center gap-1 px-3 py-1.5 rounded-md text-sm font-medium transition ${
                currentStep === 0
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
            >
              <IoArrowBack size={14} /> Back
            </button>
            <button
              onClick={handleNext}
              className="flex items-center gap-1 px-4 py-1.5 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 transition shadow-sm"
            >
              {currentStep === totalSteps - 1 ? "Finish" : "Next"}{" "}
              {currentStep !== totalSteps - 1 && <IoArrowForward size={14} />}
            </button>
          </div>
        </div>
      </div>

      {/* Optional: subtle animation */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CalenderTour;
